import Icon from 'veui/components/Icon'

Icon.register({
  folder: {
    paths: [
      {
        d: 'M4 10v29c0 1.1.9 2 2 2h36a2 2 0 002-2V15.64a2 2 0 00-2-2.01H26.44a2 2 0 01-1.5-.69l-3.58-4.12a3.1 3.1 0 00-1.8-.82H6a2 2 0 00-2 2zm23.36-.37H42a6 6 0 016 6V39a6 6 0 01-6 6H6a6 6 0 01-6-6V10a6 6 0 016-6h13.55c1.69 0 3.72.93 4.83 2.2l2.98 3.43z'
      }
    ],
    width: '48',
    height: '48'
  }
})
